import React, { useEffect, useState, useRef } from "react"
import tw from "twin.macro"

import { Container } from "./auvelity-ui"
import { handleNavClick, useWindowSize } from "../utils"

// INSTRUCTIONS
// import InternalCta
// pass an array as ctaData:
// each item in the array is an object with title, text and path

import whiteArrow from "../images/icons/cta-arrow-white.svg"
import blueArrow from "../images/icons/cta-arrow-blue.svg"

const InternalCta = ({ ctaData, variant }) => {
  const [ctaHeight, setCtaHeight] = useState(0)
  const ctas = useRef([])
  const windowSize = useWindowSize()

  useEffect(() => {
    if (windowSize.width <= 950) {
      ctas.current.forEach(cta => {
        if (cta.clientHeight > ctaHeight) {
          setCtaHeight(cta.clientHeight)
        }
      })
    }
  }, [ctas])
  return (
    <Container tw="mb-8">
      <div tw="-ml-4 mt-10 md:(flex ml-0 pt-12 mb-10 text-center mt-0 grid-cols-2 gap-6)">
        {ctaData.map((item, idx) => {
          return (
            <div
              className="group gtm-cta-click"
              key={idx}
              css={[
                tw`flex items-center mt-8 w-11/12 focus:outline-none focus-visible:(ring-4 ring-yellow) md:(mt-5 flex-col justify-between)`,
                ctaHeight > 0 && { height: ctaHeight + "px" },
              ]}
            >
              <a
                tw="w-full h-full"
                ref={element => {
                  ctas.current.push(element)
                }}
                href={item.path}
                onClick={event => {
                  handleNavClick(event, item.path)
                }}
                data-elementname={"internal cta"}
              >
                {/* bg and copy */}
                <div
                  css={[
                    tw`pr-14 pl-4 py-12 rounded-br-regular bg-grey text-left flex flex-col justify-center  w-full h-full pointer-events-none md:( p-0 pb-6 mx-auto text-center h-full)`,
                    idx === 0 && tw`  md:(rounded-none rounded-tl-regular)`,
                    idx === 1 && tw`bg-blue `,
                  ]}
                  className={`cta-wrapper ${variant === 'patient' ? 'patient-advocate-cta' : ''}`}
                >
                  <div
                    css={[
                      tw`text-xl font-bold text-blue md:(mb-4 mt-12) lg:(text-2xl)`,
                      idx === 1 && tw`text-yellow`,
                    ]}
                  >
                    {item.title}
                  </div>
                  <p
                    css={[
                      tw` text-base leading-normal md:(mx-auto text-base leading-normal mb-12 max-w-xs flex-grow) lg:(leading-normal)`,
                      idx === 1 && tw`text-white`,
                      item.textStretch && tw`md:(max-w-md)`,
                    ]}
                  >
                    {item.text}
                  </p>
                </div>
              </a>
              <div tw="mb-16 md:(mb-0)">
                <a
                  tw="w-16 md:(w-20 absolute ml-auto -translate-x-1/2)"
                  ref={element => {
                    ctas.current.push(element)
                  }}
                  href={item.path}
                  onClick={event => {
                    handleNavClick(event, item.path)
                  }}
                  data-elementname={"internal cta"}
                >
                  <span css={[tw`sr-only`]}>{item.title}</span>
                  {/* circle and arrow */}
                  <div
                    css={[
                      tw`bg-blue text-white text-center pointer-events-none rounded-full transition w-16 h-16 absolute right-4 md:(relative right-0 w-20 h-20 -mt-10)`,
                      tw`group-hover:bg-yellow group-focus-visible:bg-yellow`,
                      idx === 1 &&
                        tw`bg-yellow text-blue group-hover:bg-grey group-focus-visible:bg-grey`,
                    ]}
                    className="cta-icon"
                  >
                    <div tw="relative w-4 overflow-hidden inline-block h-16 ml-2 md:(h-20 ml-4 w-5)">
                      <div
                        css={[
                          tw`bg-white rotate-45 transform origin-top-left h-6 relative top-1/2 -translate-y-1/2 md:(h-7) `,
                          tw`group-hover:(bg-blue) group-focus-visible:(bg-blue)`,
                          idx === 1 &&
                            tw`bg-blue group-hover:(bg-white) group-focus-visible:(bg-white)`,
                        ]}
                      ></div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          )
        })}
      </div>
    </Container>
  )
}

export default InternalCta
